<template>
  <div id="app">
    <router-view />
  </div>
</template>
<style lang="scss">
@import "@/style/common.scss";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<script>
import { mapMutations } from 'vuex'
export default {
  data(){
    return {
      timer:null,
    }
  },
  created() {
    this.timer=setInterval(() => {
      this.checkLoginStatus();
    }, 15000);
  },
  methods:{
    ...mapMutations({
      add: 'SET_ROUTERS'
    }),
    checkLoginStatus() {
      var token=localStorage.getItem('token')
      if(token){
        this.axios.post('/api/User/checkUserLogin').then(response => {
          console.log('111111')
        })
        .catch(error => {
          this.$router.push('/login')
        });
      }else {
        console.log('在执行')
      }
    }
  },
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>
